/* eslint-disable */
//import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '../react/loanServicing/LoanNumberLookupForm';

class LoanServicing {
    constructor() {
        this.container = document.querySelector('#LoanServicing-App');

        if (this.container) {
            ReactDOM.render(<App />, document.getElementById('LoanServicing-App'));
        }
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {

    }
}

export default LoanServicing;